import React from 'react';

import { useTranslation } from '@crehana/i18n';

import useLocalCurrency from 'Jsx/CheckoutV4/shared/hooks/useCountryPrefix';

import Guarantee from './Guarantee';
import PaymentDisclaimer from './PaymentDisclaimer';
import PaymentTerms from './PaymentTerms';

const Legals: React.FC<{
  itemType: string | null;
  totalToPayInDollars?: number | null;
  className?: string;
  isPrecheckout?: boolean;
  hideGuarantee?: boolean;
}> = ({
  itemType,
  className,
  isPrecheckout,
  totalToPayInDollars,
  hideGuarantee,
}) => {
  const { t } = useTranslation();
  const { hasLocalCurrency } = useLocalCurrency();

  return (
    <div className={`text-base-main md:text-secondary-dark ${className}`}>
      <p className="mb-24 font-subtitle4  md:hidden">
        {t('MOBILE_GUARANTEE_TITLE')}
      </p>
      {/* Satisfaction guarantee */}
      {itemType !== 'product' && !hideGuarantee && (
        <Guarantee itemType={itemType} />
      )}
      <p className="mt-24 font-subtitle4 md:hidden">
        {t('MOBILE_DISCLAIMER_TITLE')}
      </p>
      {hasLocalCurrency && (
        <PaymentDisclaimer
          totalToPayInDollars={totalToPayInDollars}
          className="mt-16 mb-24"
        />
      )}
      {!isPrecheckout && (
        <React.Fragment>
          <p className="mb-16 font-subtitle4 md:hidden">
            {t('TERMS_CONDITIONS_TITLE')}
          </p>
          <PaymentTerms className="mt-16" />
        </React.Fragment>
      )}
    </div>
  );
};

export default Legals;
